import { EpisodeState } from "@/api/episodes-types";
import { Tag } from "@/components/ui/tags/Tag";
import { TagsDropdown } from "@/components/ui/tags/TagsDropdown";
import { Box, Stack } from "@mui/material";

type TagsCellProps = {
  params: {
    row: {
      id: string;
      tags: string[];
      state: EpisodeState;
    };
  };
  onAddTag: (episodeIds: string[], tag: string) => void;
};

export function TagsCell({ params, onAddTag }: TagsCellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Stack
        direction={"row"}
        alignItems="center"
        sx={[
          {
            flex: 1,
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "thin",
            scrollbarColor: "var(--scrollbar-color) transparent",
            "--scrollbar-color": (theme) => theme.palette.grey[400],
            "&:hover": {
              "--scrollbar-color": (theme) => theme.palette.grey[500],
            },
          },
          (theme) =>
            theme.applyStyles("dark", {
              "--scrollbar-color": theme.palette.grey[700],
              "&:hover": {
                "--scrollbar-color": theme.palette.grey[500],
              },
            }),
        ]}
        gap={0.5}
      >
        {params.row.tags.map((tag) => (
          <Tag
            key={tag}
            text={tag}
            episodeId={params.row.id}
            episodeState={params.row.state}
          />
        ))}
        {params.row.state !== EpisodeState.rejected && (
          <TagsDropdown
            onChange={(tag) => onAddTag([params.row.id], tag)}
            label="+"
            tagsToExclude={params.row.tags}
            sx={{ height: 20, width: 12, minWidth: 12, borderRadius: 4 }}
          />
        )}
      </Stack>
    </Box>
  );
}
